<div class="progress-bar-window" *ngIf="displayProcess">
  <div class="header">
    <div class="progress-bar-title">
      {{ 'vbeiProgress' | translate }}
      <span *ngIf="isCollapsed"> {{ 'vbeiStatusAvailableCount' | translate: { '0': getProcess().length } }} </span>
      <span *ngIf="isCollapsed"></span>
    </div>
    <div>
      <button class="close-btn no-border" id="close-exports" (click)="onClose()">
        <i class="ei ei-20 ei-cross"></i>
      </button>
    </div>
    <div>
      <button class="toggle-btn no-border" id="expand-collapse" (click)="onCollapseExport()">
        <i
          class="ei ei-20"
          [ngClass]="{
            'ei-chevron-down': !isCollapsed,
            'ei-chevron-up': isCollapsed
          }"
        ></i>
      </button>
    </div>
  </div>
  <div class="progress-bar-content" *ngIf="!isCollapsed">
    <div *ngFor="let progress of getProcess(); index as i" class="export-item">
      <div class="details">
        <div class="title text-ellipsis" id="notifytitle_{{ i }}">{{ progress.name }}</div>
        <div class="sub-title">
          <span *ngIf="progress.status === processStatus.Active" class="export-inprogress" id="percentage_{{ i }}"> </span>
        </div>
        <div class="col pl-0">
          <span
            id="completed-subtitle_{{ i }}"
            *ngIf="isProgressStatusValidForCompleted(progress)"
            class="export-completed"
            [ngClass]="{
              'export-completed': progress.status === processStatus.Completed,
              'export-partiallycompleted': progress.status === processStatus.Partially,
              'export-failed': progress.status === processStatus.Failed
            }"
          >
            {{ getProgressStatusTranslatedText(progress.status) }}
          </span>

          <span id="failed-subtitle_{{ i }}" *ngIf="progress.status === processStatus.Failed" class="export-failed">
            {{ 'vbeiFailed' | translate }}</span
          >
          <span id="queued_{{ i }}" *ngIf="progress.status === processStatus.New" class="export-inprogress">Queued</span>
          <div id="progress_{{ i }}" *ngIf="progress.status === processStatus.Active" class="progress-border">
            <div class="progress-continue" [ngStyle]="{ width: progress.progress + '%' }"></div>
          </div>
          <a
            *ngIf="
              isProgressStatusValid(progress) && !isDownloadTemplateProcess && !isDownloadCustomLimitSetProcess && !isDownloadGroupsProcess
            "
            class="view-status-link"
            href="javascript:void(0)"
            (click)="openImportStatusDialog(progress, '')"
            id="viewImportStatus"
            >{{ 'vbeiViewStatus' | translate }}</a
          >
          <span
            *ngIf="
              isProgressStatusValid(progress) && (isDownloadTemplateProcess || isDownloadCustomLimitSetProcess || isDownloadGroupsProcess)
            "
            class="view-status-link"
            href="javascript:void(0)"
            id="viewReDownload"
            (click)="onDownloadClick(progress.id)"
            (keydown)="onDownloadClick(progress.id)"
          >
            <i class="ei ei-download2"></i>
          </span>
        </div>
        <div class="col">
          <span *ngIf="progress.status === processStatus.Active" class="export-inprogress" id="percentage_{{ i }}">
            {{ progress.progress }}%
          </span>
        </div>
      </div>
      <div class="info-icon">
        <i
          class="ei ei-20 ei-checkmark-circle"
          id="status_icon_{{ i }}"
          [ngClass]="{
            'ei-checkmark-circle success': progress.status === processStatus.Completed || progress.status === processStatus.Ready,
            'ei-warning failed': progress.status === processStatus.Failed,
            'ei ei-notification-circle export-partiallycompleted': progress.status === processStatus.Partially
          }"
        ></i>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="showImportStatusDialog">
  <p-dialog
    [(visible)]="showImportStatusDialog"
    [modal]="true"
    [responsive]="true"
    (onHide)="closeImportStatusDialog()"
    class="dialogDim"
    [style]="{ width: '35%' }"
    header="{{ 'vbeiImportStatus' | translate }}"
  >
    <div class="grid m-0 dialogcontent">
      <div class="col-1 m-b-16" *ngIf="showSuccessInfo">
        <span class="ei-32 ei-checkmark-circle success" id="successstatusicon"></span>
      </div>
      <div class="col-11" *ngIf="showSuccessInfo">
        <span> {{ successInfo }}</span>
        <div class="col-11">
          <span class="p-badge new"> {{ createdInfo }} </span>
          <span class="m-l-4 p-badge update"> {{ updatedInfo }} </span>
          <span class="m-l-4 p-badge update" *ngIf="showNoChangesInfo"> {{ noChangesInfo }} </span>
        </div>
      </div>

      <div class="col-1 m-b-16" *ngIf="showFailednfo">
        <span class="ei-32 ei-warning failed" id="savefailedstatusicon"></span>
      </div>

      <div class="col-11" *ngIf="showFailednfo">
        <span class="failed"> {{ 'vbeiImportFailedLabel' | translate }} </span>
        <div class="col pl-0" [innerHTML]="failedInfoInvalidStructure"></div>
      </div>

      <div class="col-1 m-b-16" *ngIf="showSyntaxErrornfo">
        <i class="ei-warning ei-32 failed" id="validationfailedstatusicon"></i>
      </div>
      <div class="col-11 sub-title failedinfo" *ngIf="showSyntaxErrornfo">
        <div class="m-2">{{ failedInfo }}</div>
        <div *ngIf="showValidationErros">
          <table class="styled-table">
            <thead>
              <tr>
                <th scope="col">{{ 'vbeiReferenceName' | translate }}</th>
                <th scope="col" *ngIf="hasRowNumber">{{ 'vbeiRowNumber' | translate }}</th>
                <th scope="col">{{ 'vbeiError' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let validation of validationDetails">
                <td>{{ validation.customState.ruleName }}</td>
                <td *ngIf="hasRowNumber">{{ validation.customState.rowNumber }}</td>
                <td>{{ validation.msg }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <ng-template #footer>
      <div class="text-right">
        <button pButton class="p-button" type="button" [label]="'vbeiOkBtn' | translate" (click)="closeImportStatusDialog()">
          {{ 'vbeiOkBtn' | translate }}
        </button>
      </div>
    </ng-template>
  </p-dialog>
</ng-container>
<app-file-download></app-file-download>
